import { AllQuotesOffer, RateQuote } from '../rate-quote/types';

export const isSameOffer = (offers: RateQuote['offers'], o: AllQuotesOffer) =>
  Object.values(offers).find((offer) => o.offerId === offer.offerId);
